<template>
  <el-dialog
    :model-value="visible"
    title="Criterios de Visualización"
    width="60vw"
    top="8vh"
    class="criterios-dialog"
    @update:model-value="$emit('update:visible', $event)"
    @close="$emit('close')"
  >
    <div v-if="relacion">
      <el-descriptions
        :column="2"
        border
        class="mb-4"
      >
        <el-descriptions-item label="Atributo">
          {{ relacion.Atributo?.Etiqueta }}
        </el-descriptions-item>
        <el-descriptions-item label="Entidad">
          {{ nombreEntidad }}
        </el-descriptions-item>
      </el-descriptions>

      <el-alert
        v-if="editable"
        type="warning"
        :closable="false"
        class="mb-3"
        show-icon
      >
        <strong>Regla automática:</strong> Al marcar como editable, el atributo se marcará
        automáticamente como visible en todos los módulos.
      </el-alert>

      <el-tabs
        v-model="activeTab"
        type="card"
      >
        <!-- Tab: Tipos de Elemento -->
        <el-tab-pane
          label="Tipos de Elemento"
          name="elementoTipos"
        >
          <CriteriosElementoTipoTab
            :elemento-tipos="elementoTipos"
            :modulos="modulosSistema"
            :loading="loading"
            :saving="saving"
            @guardar="$emit('guardar-elemento-tipo')"
          />
        </el-tab-pane>

        <!-- Tab: Categorías de Material (solo para Material) -->
        <el-tab-pane
          v-if="esMaterial"
          label="Categorías de Item"
          name="materialCategorias"
        >
          <CriteriosMaterialCategoriaTab
            :material-categorias="materialCategorias"
            :modulos="modulosSistema"
            :loading="loading"
            :saving="saving"
            @guardar="$emit('guardar-material-categoria')"
          />
        </el-tab-pane>

        <!-- Tab: Procesos (solo para Proceso) -->
        <el-tab-pane
          v-if="esProceso"
          label="Procesos"
          name="procesos"
        >
          <CriteriosProcesoTab
            :procesos="procesos"
            :modulos="modulosSistema"
            :loading="loading"
            :saving="saving"
            @guardar="$emit('guardar-procesos')"
          />
        </el-tab-pane>
      </el-tabs>
    </div>

    <template #footer>
      <el-button @click="$emit('update:visible', false)">Cerrar</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue';
import CriteriosElementoTipoTab from './CriteriosElementoTipoTab.vue';
import CriteriosMaterialCategoriaTab from './CriteriosMaterialCategoriaTab.vue';
import CriteriosProcesoTab from './CriteriosProcesoTab.vue';

defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  relacion: {
    type: Object,
    default: null,
  },
  nombreEntidad: {
    type: String,
    default: '',
  },
  esMaterial: {
    type: Boolean,
    default: false,
  },
  esProceso: {
    type: Boolean,
    default: false,
  },
  editable: {
    type: Boolean,
    default: false,
  },
  elementoTipos: {
    type: Array,
    default: () => [],
  },
  materialCategorias: {
    type: Array,
    default: () => [],
  },
  procesos: {
    type: Array,
    default: () => [],
  },
  modulosSistema: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  saving: {
    type: Boolean,
    default: false,
  },
});

defineEmits([
  'update:visible',
  'close',
  'guardar-elemento-tipo',
  'guardar-material-categoria',
  'guardar-procesos',
]);

const activeTab = ref('elementoTipos');
</script>

<style scoped>
.mb-3 {
  margin-bottom: 12px;
}

.mb-4 {
  margin-bottom: 16px;
}

.criterios-dialog :deep(.el-dialog) {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.criterios-dialog :deep(.el-dialog__body) {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  max-height: calc(85vh - 120px);
}
</style>
